const UoMIndex = () => import("./UoM/index.vue");
const NewUoM = () => import("./UoM/_pages/create.vue");

// uom group
const UoMGroupsIndex = () => import("./UoM-groups/index.vue");
const NewUoMGroup = () => import("./UoM-groups/_pages/create.vue");
const UoMGroupDefinition = () => import("./UoM-groups/_pages/definition.vue");

// taxes
const TaxIndex = () => import("./taxes/index.vue");
const NewTaxGroup = () => import("./taxes/_pages/create.vue");
const TaxGroupDetails = () => import("./taxes/_pages/view.vue");
const ReceiptIndex = () => import("./printer-setup/index.vue");
const ReceiptRowIndex = () => import("./printer-setup/create-row.vue");

// main setup
const MainSetup = () => import("./main-setup.vue");
const AccountsSetup = () => import("./accounts-setup.vue");

// payment modes
const PaymentModeIndex = () => import("./payment-modes/index.vue");
const NewPaymentMode= () => import("./payment-modes/_pages/create.vue");
const ViewPaymentMode= () => import("./payment-modes/_pages/view.vue");

const TableEditing = () => import("./editing-2.vue");

export default [
  {
    path: "/table-editing",
    component: TableEditing,
  },
  {
    path: "/payment-modes",
    component: PaymentModeIndex,
  },
  {
    path: "/payment-modes/:id",
    component: ViewPaymentMode,
  },
  {
    path: "/new-payment-mode",
    component: NewPaymentMode,
  },
  {
    path: "/accounts-setup",
    component: AccountsSetup,
  },
  {
    path: "/master-data-setup",
    component: MainSetup,
  },
  {
    path: "/create-receipt-row",
    component: ReceiptRowIndex,
  },
  {
    path: "/printer-setup",
    component: ReceiptIndex,
  },
  {
    path: "/inventory/uom",
    component: UoMIndex,
  },
  {
    path: "/inventory/new-uom",
    component: NewUoM,
  },
  {
    path: "/inventory/uom-groups",
    component: UoMGroupsIndex,
  },
  {
    path: "/inventory/new-uom-group",
    component: NewUoMGroup,
  },
  {
    path: "/uom-group/definition/:id",
    component: UoMGroupDefinition,
  },
  {
    path: "/tax-groups",
    component: TaxIndex,
  },
  {
    path: "/tax-groups/details/:id",
    component: TaxGroupDetails,
  },
  {
    path: "/tax-groups/create",
    component: NewTaxGroup,
  },
];
